// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"18":"product","242":"project","443":"about"}[chunkId] + "." + {"18":"9ca07793","242":"df296205","443":"b917f112"}[chunkId] + ".css";
};